import { merge } from 'lodash'
import organizations from './Organizations/organizations.lang'
import profile from './Profile/profile.lang'

const messages = merge(organizations, profile)

export default messages
